import api from '@/services/utils/base';
import store from '@/store';

const defaultGrouping =     [
    {
        'isOpened': true,
        'columns': [
            'workspaces-name',
            'campaigns-id',
            'campaigns-name',
            'campaigns-externalid',
            'campaigns-externalstatus',
            'campaigns-costmodel',
            'campaigns-costvalue',
            'campaigns-countryid',
            'campaigns-created',
            'campaigns-updated',
            'campaigns-updatedby',
            'campaigns-trafficsourceid',
            'campaigns-url',
            'offers-id',
            'offers-name',
            'offers-affiliatenetworkid',
            'offers-countryid',
            'offers-created',
            'offers-updated',
            'offers-updatedby',
            'offers-url',
            'offers-payout',
            'landings-id',
            'landings-name',
            'landings-countryid',
            'landings-created',
            'landings-offers',
            'landings-updated',
            'landings-updatedby',
            'landings-url',
            'traffic_sources-id',
            'traffic_sources-name',
            'traffic_sources-costparam',
            'traffic_sources-extclickidparam',
            'traffic_sources-postbackurl',
            'traffic_sources-created',
            'traffic_sources-updated',
            'traffic_sources-updatedby',
            'traffic_sources-custom10param',
            'traffic_sources-custom1param',
            'traffic_sources-custom2param',
            'traffic_sources-custom3param',
            'traffic_sources-custom4param',
            'traffic_sources-custom5param',
            'traffic_sources-custom6param',
            'traffic_sources-custom7param',
            'traffic_sources-custom8param',
            'traffic_sources-custom9param',
            'affiliate_networks-id',
            'affiliate_networks-name',
            'affiliate_networks-appendclickid',
            'affiliate_networks-created',
            'affiliate_networks-updated',
            'affiliate_networks-updatedby',
            'affiliate_networks-postbackonlywhiteips',
            'flows-id',
            'flows-name',
            'flows-created',
            'flows-landingsAmount',
            'flows-offersAmount',
            'flows-updated',
            'flows-updatedby',
            'reports-custom1',
            'reports-custom2',
            'reports-custom3',
            'reports-custom4',
            'reports-custom5',
            'reports-custom6',
            'reports-custom7',
            'reports-custom8',
            'reports-custom9',
            'reports-custom10',
            'reports-custom1masked',
            'reports-custom2masked',
            'reports-custom3masked',
            'reports-custom4masked',
            'reports-custom5masked',
            'reports-custom6masked',
            'reports-custom7masked',
            'reports-custom8masked',
            'reports-custom9masked',
            'reports-custom10masked',
            'reports-isp',
            'reports-language',
            'reports-mobilecarrier',
            'reports-month',
            'reports-os',
            'reports-osversion',
            'reports-screenresolution',
            'reports-state',
            'reports-subnetbig',
            'reports-subnetsmall',
            'referrer_domains-name',
            'referrers-referrer',
            'reports-browser',
            'reports-browserversion',
            'reports-city',
            'reports-connecttype',
            'reports-country',

        ],
        'groupId': 'general'
    },
    {
        'isOpened': true,
        'columns': [
            'reports-impressions',
            'reports-visits',
            'reports-clicks',
            'reports-conversions'
        ],
        'groupId': 'total_events_data'
    },
    {
        'isOpened': true,
        'columns': [
            'reports-cost',
            'reports-revenue',
            'reports-profit'
        ],
        'groupId': 'basic_financial_data'
    },
    {
        'isOpened': true,
        'columns': [
            'reports-cpv',
            'reports-cpc',
            'reports-cpa',
            'reports-ctr',
            'reports-1xctr',
            'reports-uctr',
            'reports-cr',
            'reports-1xcr',
            'reports-cv',
            'reports-1xcv',
            'reports-epc',
            'reports-epv',
            'reports-roi',
            'reports-ap',
        ],
        'groupId': 'key_performance_data'
    },
    {
        'isOpened': true,
        'columns': [
            'reports-clicksuniq',
            'reports-impressionsuniq',
            'reports-visitsuniq',
            'reports-clickswebview',
            'reports-impressionswebview',
            'reports-visitswebview',
            'reports-clicksbot',
            'reports-impressionsbot',
            'reports-visitsbot',
            'reports-costbot'
        ],
        'groupId': 'advanced_data_on_events'
    },
    {
        'isOpened': true,
        'columns': [
            'reports-clickssuspicious',
            'reports-clickssuspiciousblacklistedips',
            'reports-clickssuspiciousdatacenterips',
            'reports-clicks_fast_clicker',
            'reports-clicks_suspicious_ip_with_frequent_events',
            'reports-clicks_suspicious_ip_with_frequent_campaign_events',
            'reports-impressionssuspicious',
            'reports-impressionssuspiciousblacklistedips',
            'reports-impressionssuspiciousdatacenterips',
            'reports-impressions_suspicious_ip_with_frequent_campaign_events',
            'reports-impressions_suspicious_ip_with_frequent_events',
            'reports-visitssuspicious',
            'reports-visitssuspiciousblacklistedips',
            'reports-visitssuspiciousdatacenterips',
            'reports-visits_suspicious_ip_with_frequent_campaign_events',
            'reports-visits_suspicious_ip_with_frequent_events'
        ],
        'groupId': 'ivt'
    },
    {

        'isOpened': true,
        'columns': [
            'reports-conversioncharge',
            'reports-conversionconfirm',
            'reports-conversiondecline',
            'reports-conversionnew',
            'reports-conversionsent',
            'reports-conversionswebview',
            'reports-conversionconfirmrevenue',
            'reports-hiddenrevenue',
            'reports-conversionconfirmhiddenrevenue',
            'reports-conversionchargerevenue',
            'reports-conversionswebviewrevenue',
            'reports-hiddenprofit'
        ],
        'groupId': 'advanced_conversions_data'
    },
    {

        'isOpened': true,
        'columns': [
            'reports-customevent_reg',
            'reports-customeventhiddenrevenue_reg',
            'reports-customeventrevenue_reg'
        ],
        'groupId': 'custom_columns'
    },
]

export default class ColumnsGroupsSetting {
  getColumnsGroupsSetting() {
    return api.get('columns-groups-setting')
      .then((res: Bemob.RawResponse<ColumnsGroupsSettingServerFormat[]>) => {
        store.dispatch('setGroupsColumns', res.data.payload?.length ? res.data.payload : defaultGrouping)
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        store.dispatch('setGroupsColumns',  defaultGrouping)
        return Promise.reject(err);
      });
  }

  postColumnsGroupsSetting(payload: ColumnsGroupsSettingServerFormat[]) {
    return api.post('columns-groups-setting',payload)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }
  
}
